import { motion } from "framer-motion";
import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { CONTACT } from "@/lib/site";
import { LogoMark } from "@/components/site/LogoMark";

export const ContactFooter = () => {
  return (
    <footer id="contact" data-testid="contact-footer" className="bg-[#0A0A0A] text-white pt-24 md:pt-32 px-6 md:px-12 lg:px-16">
      <div className="mx-auto max-w-[1400px]">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-xs tracking-[0.25em] uppercase font-bold text-gray-500 mb-6"
        >
          Let's build something reliable
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-heading font-black tracking-tighter leading-none text-[18vw] md:text-[10vw]"
        >
          LET'S TALK.
        </motion.h2>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-8 border-t border-[#27272A] pt-12">
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="footer-email-link"
            className="group flex items-center justify-between border border-[#27272A] hover:border-[#0047AB] p-8 transition-colors"
          >
            <div className="flex items-start gap-4">
              <Mail className="h-6 w-6 text-[#0047AB] mt-1" strokeWidth={1.5} />
              <div>
                <p className="font-mono text-xs uppercase tracking-widest text-gray-500">Email &amp; Address</p>
                <div className="mt-1 text-sm leading-relaxed text-gray-400">
                  <p>Rae Cloud LLC</p>
                  <p>539 W. Commerce St #2981</p>
                  <p>Dallas, TX 75208</p>
                </div>
                <p className="mt-2 text-lg font-medium text-white">{CONTACT.email}</p>
              </div>
            </div>
            <ArrowUpRight className="h-5 w-5 text-gray-500 group-hover:text-white transition-colors shrink-0" />
          </a>

          <a
            href={CONTACT.phoneHref}
            data-testid="footer-phone-link"
            className="group flex items-center justify-between border border-[#27272A] hover:border-[#0047AB] p-8 transition-colors"
          >
            <div className="flex items-center gap-4">
              <Phone className="h-6 w-6 text-[#0047AB]" strokeWidth={1.5} />
              <div>
                <p className="font-mono text-xs uppercase tracking-widest text-gray-500">Phone</p>
                <p className="text-lg font-medium">{CONTACT.phone}</p>
              </div>
            </div>
            <ArrowUpRight className="h-5 w-5 text-gray-500 group-hover:text-white transition-colors" />
          </a>
        </div>

        <div className="mt-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-[#27272A] py-8">
          <div className="flex items-center gap-3">
            <LogoMark size={40} />
            <span className="font-heading text-xl font-extrabold tracking-tight">Rae Cloud LLC</span>
          </div>
          <p className="text-sm text-gray-500">
            &copy; 2019 Rae Cloud LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
